import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import MobileCallFab from "@/components/site/MobileCallFab";

export default function Layout({ children }) {
  return (
    <>
      <Header />
      <main className="bg-white">{children}</main>
      <Footer />
      <MobileCallFab />
    </>
  );
}
